import React, { useState, useEffect } from 'react';
import './Annotation.scss';
import __ from './../utils/translation';
import $ from "jquery";
import { downloadImage, downloadSVG } from '../utils/downloadImage';
import { applyZoom, zoomWithKeys, zoomWithMouse, zoomOptions } from '../utils/zoom';
import { ReactComponent as IconDownload2 } from '../icons/file_download.svg';

const Clone = ({ canvas }) => {

    return (
        <>
            {/**<p className="title">{__('CLONE')}</p>

            <div id="options-general">
                <div className='option-general mb-2'>
                    <span>Estado Clone:</span>
                    <div className='value-general'>
                        <input id="state-clone" type='checkbox'></input>
                    </div>
                </div>
                <div className='option-general mb-2 cloneOpt'>
                    <span>Estado das Flechas:</span>
                    <div className='value-general'>
                        <input id="state-trans" type='checkbox'></input>
                    </div>
                </div>
                <button id="state-pos" className='cloneOpt'>Mode Mover</button>
                <button id="state-rot" className='cloneOpt'>Mode Rotacionar</button>
            </div> */}

        </>
    )
}

export default Clone